import React from "react";
import Meta from "./../components/Meta";
import FaqSection2 from "./../components/FaqSection2";
import FaqSection from "./../components/FaqSection";

function FaqPage(props) {
  return (
    <>
      <Meta title="Faq" />
      <FaqSection2
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="Frequently Asked Questions"
        subtitle=""
      />
      {/* <FaqSection
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="Frequently Asked Questions"
        subtitle="Here are some answers to the questions we hear from people the most."
      /> */}
    </>
  );
}

export default FaqPage;
